import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { selectCurrentUser } from '../store/slices/authSlice';
import { updateUser } from '../store/slices/authSlice';
import Layout from '../components/Layout';
import authService from '../services/auth';
import './Profile.css';

const Profile = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectCurrentUser);
  const [name, setName] = useState(user?.name ?? '');
  const [editingName, setEditingName] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  if (!user) {
    return null;
  }

  const handleSaveName = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage({ type: '', text: '' });
    try {
      const response = await authService.updateProfile({ name: name.trim() || null });
      dispatch(updateUser(response.data.user));
      setEditingName(false);
      setMessage({ type: 'success', text: 'Name updated successfully.' });
    } catch (err) {
      setMessage({
        type: 'error',
        text: err.response?.data?.message || 'Failed to update name. Please try again.',
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Layout>
      <div className="profile-page">
        <div className="profile-container">
          <h1>Profile</h1>
          {message.text && (
            <div className={`profile-message ${message.type === 'success' ? 'success' : 'error'}`}>
              {message.text}
            </div>
          )}
          <div className="profile-card">
            <div className="profile-field">
              <label>Full Name</label>
              {editingName ? (
                <form onSubmit={handleSaveName} className="profile-edit-form">
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter your full name"
                    className="profile-edit-input"
                    autoFocus
                  />
                  <div className="profile-edit-actions">
                    <button type="submit" className="profile-btn primary" disabled={saving}>
                      {saving ? 'Saving...' : 'Save'}
                    </button>
                    <button
                      type="button"
                      className="profile-btn secondary"
                      onClick={() => {
                        setEditingName(false);
                        setName(user?.name ?? '');
                        setMessage({ type: '', text: '' });
                      }}
                      disabled={saving}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              ) : (
                <>
                  <span>{user.name && user.name.trim() ? user.name : 'Not set'}</span>
                  <button
                    type="button"
                    className="profile-edit-link"
                    onClick={() => {
                      setName(user?.name ?? '');
                      setEditingName(true);
                    }}
                  >
                    {user.name && user.name.trim() ? 'Edit name' : 'Add name'}
                  </button>
                </>
              )}
            </div>
            <div className="profile-field">
              <label>Email</label>
              <span>{user.email || '—'}</span>
            </div>
            <div className="profile-field">
              <label>Phone</label>
              <span>{user.phone || '—'}</span>
            </div>
            <div className="profile-field">
              <label>Account status</label>
              <span className="profile-status">{user.status || 'active'}</span>
            </div>
            <div className="profile-field">
              <label>Password</label>
              <span>********</span>
              <Link to="/update-password" className="profile-edit-link">
                Change password
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
